var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 59,
    viewBox: "0 0 48 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86621 2.49077C7.204 2.902 9.09752 5.46492 10.9888 6.74994C13.8654 8.70452 16.5141 11.0203 19.488 12.8251C21.788 14.221 23.9455 16.0016 26.3726 17.1758C30.8493 19.3413 35.0686 22.1465 39.1473 24.9886C40.7761 26.1235 42.526 27.0477 43.9782 28.4116C44.6309 29.0246 45.1948 29.5717 45.7865 30.2407C46.3432 30.8699 45.6788 31.1212 45.2957 31.5733C41.4373 36.1264 37.2482 39.4451 31.8235 41.8946C28.9105 43.21 25.7653 43.9494 22.898 45.3437C20.7449 46.3908 18.9972 47.9269 17.008 49.2371C15.1799 50.4411 13.65 52.25 11.9704 53.64C11.0783 54.3783 5.24832 57.6257 4.85329 56.8931C3.04355 53.5372 2.33522 50.0175 2.30869 46.1799C2.27879 41.8557 2.07618 37.552 2.07618 33.2195C2.07618 28.551 2.07618 23.8824 2.07618 19.2139C2.07618 15.5652 1.68635 11.5849 2.67036 8.0303C3.1642 6.24634 3.48065 4.40939 4.22037 2.72594C4.70392 1.62547 5.09871 1.83417 5.09871 2.96111",
    stroke: "#D9FC51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.65688d6bea9ef383aa494936b8235472.svg";
export { ForwardRef as ReactComponent };